module.exports = __webpack_public_path__ + "img/arrow-down.b1e484b.svg";